import { VatikaUserList } from '../../constants/constants';

export const PROFILE_MENU_ITEM_IDS = [
  'profile',
  'notifications',
  'logout',
  'stopViewAs',
  'viewAs',
  'about',
] as const;

export type ProfileMenuItemId = (typeof PROFILE_MENU_ITEM_IDS)[number];

export interface ProfileMenuAccess {
  canViewAs: boolean;
  isViewing: boolean;
}

const ITEM_RULES: Record<ProfileMenuItemId, (access: ProfileMenuAccess) => boolean> = {
  profile: () => true,
  notifications: () => true,
  logout: () => true,
  stopViewAs: ({ isViewing }) => isViewing,
  viewAs: ({ canViewAs, isViewing }) => canViewAs && !isViewing,
  about: () => true,
};

export const visibleProfileMenuItems = (access: ProfileMenuAccess): readonly ProfileMenuItemId[] =>
  PROFILE_MENU_ITEM_IDS.filter((id) => ITEM_RULES[id](access));

export const isVatikaUser = (email: string): boolean => VatikaUserList.includes(email);
